import { useDispatch, useSelector } from "react-redux";
import { useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';
import { CellType, isEmpty, setglobaldata, getglobaldata, isEnabled, isFalse } from '../modules/appLibrary';
import { perfMasterRequest, perfMasterResponse } from '../modules/perfTrace';
import { unstable_batchedUpdates } from 'react-dom';

// マスタ照会の飛行中要求(同一キーは相乗りさせる)と、該当なしキー(再照会を止める)。
// 応答が返る前に同じ要求が何百件も発射されるため、応答時のキャッシュだけでは止められない。
const masterInflight = new Map();
const masterNotFound = new Set();
// 全 postaxios の飛行中件数。画面側が「通信が全て終わったか」を判定するために使う。
let activeAxiosCount = 0;
export function getActiveAxiosCount() { return activeAxiosCount; }
function masterCacheKey(dataid, code, keyinfo) {
    return String(dataid ?? '') + '|' + String(code ?? '') + '|' + String(keyinfo ?? '');
}
// 待機カーソルは要求数を数えて対称に消す(コールバックを渡すと誰も消さないため残り続けていた)。
let waitCursorCount = 0;
import axios from "axios";
import { getAxiosAuthConfig, getResponseErrorDescription, hasValidLoginSession, isUnauthorizedResponse } from '../modules/authToken';
import {
    wait, success, successmsg, warnning, showwarndescription, clearwardescription, modify, clearentrytrigger, entryrerender, waitcursor,
    showconvdescription, clearconvdescription, entrylayoutopen, entrylayoutclose, entrysettingopen, masonrydata, datatreeopen, rerendergrid, setgridmaximize
} from '../modules/formstore';
import { warnmsg,infomsg, confmsg, confmsg2 } from '../modules/msgboxstore';
import { resetstore } from '../modules/menustore';
import { resetenv } from '../modules/environstore';
import { resetuser } from '../modules/userstore';
import { searchlistopen, searchlistclose, stickysearchopen, datepickeropen, colorpickeropen, washpickeropen, searchskuopen, datepickerclose } from '../modules/searchliststore';
import { tagsearchclose } from '../modules/tagsearchliststore';
import { formdlgopen, formdlgclose } from '../modules/formdlgstore';
import { popupopen } from '../modules/popuptextstore';
import { saveAs } from "file-saver";
import { continueSession } from '../modules/appLibrary';

//---------------------------------------------------------------------
//  Common Library
//---------------------------------------------------------------------
export function buildPostErrorMessage(url, callback = {}, data = {}) {
    let msg = "処理に失敗しました。（" + url + "）";
    if (!isEmpty(callback.errmsg)) {
        msg = callback.errmsg;
    }
    if (!isEmpty(data.errDescription)) {
        msg = data.errDescription;
    }
    return msg;
}

export default function ComFunction(props, ref) {
    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const gridlist = useSelector(state => state.form.gridlist);
    const changeurl = useSelector(state => state.form.changeurl);
    const menus = useSelector(state => state.menu.menus);       //個人メニュまたは既定メニュ
    const menudata = useSelector(state => state.menu);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const history = useHistory();
    const CELLTYPE = CellType();

    useImperativeHandle(ref, () => ({
        //axios実行
        postaxios(url, param, callback, waitmode) {
            if (!ensureValidLoginSession()) {
                handleLoginExpired();
                return;
            }
            let data = { corpkey: corpkey, account: account};
            if (param !== null) {
                for (let key in param) {
                    data[key] = param[key];
                }
            }
            if (!isEmpty(changeurl)) {
                //WebApiURL変換
                url = replaceChangeUrl(url, changeurl);
            }
            postexecute(url, data, callback, waitmode);
            function replaceChangeUrl(url, changeurl) {
                let result = url;

                changeurl.forEach(item => {
                    const index = item.indexOf("=");

                    // "=" がない場合はスキップ
                    if (index === -1) return;

                    const from = item.substring(0, index);
                    const to = item.substring(index + 1);

                    if (!from) return;

                    // 大文字小文字を区別しないで置換
                    const regex = new RegExp(escapeRegExp(from), "gi");
                    result = result.replace(regex, to);
                });

                return result;
                function escapeRegExp(str) {
                    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                }           }
        },
        //fileupload
        fileupload(url, param, callback) {
            if (!ensureValidLoginSession()) {
                handleLoginExpired();
                return;
            }
            uploadexecute(url, param, callback);
        },
        //filedownload
        filedownload(url, param) {
            if (!ensureValidLoginSession()) {
                handleLoginExpired();
                return;
            }
            downloadexecute(url, param);
        },
        wait(open) {
            dispatch(wait(open));
        },
        waitcursor(wait) {
            dispatch(waitcursor(wait));
        },
        success() {
            dispatch(success(true));
        },
        successmsg(msg) {
            dispatch(successmsg(msg));
        },
        modify(flag) {
            dispatch(modify(isEmpty(flag) ? true: flag));
        },
        closewarnning() {
            dispatch(warnning(false));
            dispatch(clearwardescription());
        },
        showwarndescription(msg, list) {
            dispatch(showwarndescription({ msg: msg, warnlist: list }));
        },
        showconvdescription(list) {
            dispatch(showconvdescription(list));
        },
        clearconvdescription() {
            dispatch(clearconvdescription());
        },
        warnmsg(msg) {
            dispatch(warnmsg(msg));
        },
        infomsg(msg, doCmd) {
            dispatch(infomsg({ msg: msg, cmd: doCmd }));
        },
        confmsg(msg, doCmd, cancelCmd, label1) {
            if (isEmpty(label1)) label1 = "";
            dispatch(confmsg({ msg: msg, cmd: doCmd, cancel: cancelCmd, label1: label1 }));
        },
        confmsg2(msg, doCmd, doCmd2, label1, label2) {
            dispatch(confmsg2({ msg: msg, cmd: doCmd, cmd2: doCmd2, label1:label1, label2:label2 }));
        },
        searchlistopen(payload) {
            if (payload.data.datatype === CELLTYPE.STICKY)
                dispatch(stickysearchopen(payload));
            else if (payload.data.datatype === CELLTYPE.DATE || payload.data.datatype === CELLTYPE.YEAR ||
                     payload.data.datatype === CELLTYPE.SEARCHDATE || payload.data.datatype === CELLTYPE.SEARCHYM || payload.data.datatype === CELLTYPE.SEARCHYMRANGE ||
                     payload.data.datatype === CELLTYPE.SEARCHYMSTR || payload.data.datatype === CELLTYPE.SEARCHYMRANGESTR)
                dispatch(datepickeropen(payload));
            else if(payload.data.datatype === CELLTYPE.COLOR )
                dispatch(colorpickeropen(payload));
            else
                if (this.isSKU(payload.data.dataid))
                    dispatch(searchskuopen(payload));
                else
                    dispatch(searchlistopen(payload));
        },
        isSKU(dataid) {
            return (dataid === "d_prod_color" || dataid === "d_prod_size" ||
                    dataid === "d_inst_color" || dataid === "d_inst_size" ||
                    dataid === "d_slip_color" || dataid === "d_slip_size" ||
                    dataid === "m_matl_color" || dataid === "m_smatl_color" || dataid === "m_smatl_size")
        },
        isSKUColor(dataid) {
            return (dataid === "d_prod_color" || dataid === "d_inst_color" || dataid === "d_slip_color" || dataid === "m_matl_color" || dataid === "m_smatl_color")
        },
        isSKUSize(dataid) {
            return (dataid === "d_prod_size" || dataid === "d_inst_size" || dataid === "d_slip_size" || dataid === "m_matl_size" ||dataid === "m_smatl_size")
        },
        washlistopen(payload) {
            dispatch(washpickeropen(payload));
        },
        searchlistclose() {
            dispatch(searchlistclose());
        },
        datepickerclose() {
            dispatch(datepickerclose());
        },
        tagsearchclose() {
            dispatch(tagsearchclose());
        },
        formdialogopen(payload) {
            payload.open = true;
            if (payload.cmdlabel === undefined) payload.cmdlabel = "実行";
            if (payload.dialogtype === undefined) payload.dialogtype = 0;
            dispatch(formdlgopen(payload));
        },
        formdialogclose() {
            dispatch(formdlgclose());
        },
        datatreeopen(list) {
            dispatch(datatreeopen({ datatreeopen: true, datatreelist: list }));
        },
        datatreeclose() {
            dispatch(datatreeopen({ datatreeopen: false, datatreelist: [] }));
        },
        popupopen(payload) {
            dispatch(popupopen(payload));
        },
        entrylayoutopen(type) {
            dispatch(entrylayoutopen(type));
        },
        entrylayoutclose() {
            dispatch(entrylayoutclose());
        },
        entrysettingopen() {
            dispatch(entrysettingopen(true));
        },
        masonrydata(data) {
            dispatch(masonrydata(data));
        },
        clearentrytrigger() {
            dispatch(clearentrytrigger());
        },
        entryrerender() {
            dispatch(entryrerender());
        },
        rerenderGrid(id) {
            dispatch(rerendergrid({ rerendergrid: id }));
        },
        gridmaximize(id, flag) {
            dispatch(setgridmaximize({id: id, flag: flag }));
        },
        //Entry Input値をセット
        setdomValue(id, value, type) {
            if (isEmpty(type)) type = "100";
            let elem = document.getElementById(id + '_' + type);
            if (!isEmpty(elem)) {
                elem.value = value;
            }
        },
        //masterdata初期値セット
        initMaster(data) {
            // 画面初期化時は該当なし判定をやり直す。
            masterNotFound.clear();
            setglobaldata("masterdata", data);
        },
        //dataidに対するデータを洗い替え
        asignMaster(dataid, data) {
            let masterdata = getglobaldata("masterdata");
            if (isEmpty(masterdata)) {
                this.initMaster(data);
            } else {
                let keyinfo = data[0].keyinfo;
                const master = masterdata.filter((data) => {
                    return data.dataid !== dataid || data.keyinfo !== keyinfo;
                });
                setglobaldata("masterdata", [...master,...data]);
            }
        },
        //masterdataをマージ
        margeMaster(data) {
            if (isEmpty(data)) return;
            let masterdata = getglobaldata("masterdata");
            if (isEmpty(masterdata)) {
                this.initMaster(data);
            } else {
                if (masterdata.length === 0) {
                    this.initMaster(data);
                } else {
                    //masterdata = Object.assign(masterdata, data);
                    for (let i = 0; i < data.length; i++) {
                        if ("keyinfo" in data[i]) {
                            if (!masterdata.some(e => e.dataid === data[i].dataid && e.code === String(data[i].code) && e.keyinfo === data[i].keyinfo)) {
                                masterdata.push(data[i]);
                            }
                        } else {
                            if (!masterdata.some(e => e.dataid === data[i].dataid && e.code === String(data[i].code))) {
                                masterdata.push(data[i]);
                            }
                        }
                    }
                    setglobaldata("masterdata", masterdata);
                }
            }
        },
        //masterが存在するかチェック
        existMaster(dataid, code, keyinfo) {
            let masterdata = getglobaldata("masterdata");
            if (isEmpty(masterdata)) return false;
            if (isEmpty(keyinfo))
                return masterdata.find(e => e.dataid === dataid && e.code === String(code)) !== undefined;
            else
                return masterdata.find(e => e.dataid === dataid && e.code === String(code) && e.keyinfo === keyinfo) !== undefined;
        },
        //master追加/更新
        setMaster(data) {
            // 値が取得できたキーは該当なし判定から外す。
            if (!isEmpty(data)) masterNotFound.delete(masterCacheKey(data.dataid, data.code, data.keyinfo));
            let masterdata = getglobaldata("masterdata");
            if (isEmpty(masterdata)) {
                this.initMaster([data]);
            } else {
                var master = masterdata;
                let keyinfo = data["keyinfo"];
                if (this.existMaster(data.dataid, data.code, keyinfo)) {
                    if (isEmpty(keyinfo)) {
                        master = master.filter((item) => {
                            return !((item.dataid === data.dataid) && (item.code === data.code));
                        });
                    } else {
                        master = master.filter((item) => {
                            return !((item.dataid === data.dataid) && (item.code === data.code) && item.keyinfo === keyinfo);
                        });
                    }
                }
                master.push(data);
                setglobaldata("masterdata", master);
            }
        },
        //master取得　notfound=null
        getMaster(dataid, code, keyinfo) {
            let masterdata = getglobaldata("masterdata");
            if (isEmpty(masterdata)) return null;
            let result = null;
            if (isEmpty(keyinfo))
                result = masterdata.find(e => e.dataid === dataid && e.code === String(code))
            else
                result = masterdata.find(e => e.dataid === dataid && e.code === String(code) && e.keyinfo === keyinfo);
            return result === undefined ? null : result;
        },
        //master削除
        removeMaster(dataid, code) {
            if (this.existMaster(dataid, code)) {
                let masterdata = getglobaldata("masterdata");
                const master = masterdata.filter((data) => {
                    return !((data.dataid === dataid) && (data.code === String(code)));
                });
                setglobaldata("masterdata", master);
            }
        },
        //マスタデータ取得
        getMasterdata(dataid, code, keyinfo, param, rowdata, callback, wait) {
            if (isEmpty(code)) {
                callback(null);
                return;
            }
            // wait を明示的に true にしたときだけ待機表示。省略時は 'nowait'。
            // 従来は isFalse(undefined) が true を返すため 'wait' のままとなり、
            // 応答が返るまで .loading-overlay が画面全体を覆っていた。
            var waitmode = isEnabled(wait) ? 'wait' : 'nowait';
            const cacheKey = masterCacheKey(dataid, code, keyinfo);
            // 既に該当なしと分かっているキーは通信しない。
            // 同期で callback を呼ぶと表示→再取得の無限再帰になるため必ず非同期にする。
            if (masterNotFound.has(cacheKey)) {
                setTimeout(function () { callback(null); }, 0);
                return;
            }
            // 同一キーが飛行中なら相乗りする。
            const waitingCallbacks = masterInflight.get(cacheKey);
            if (waitingCallbacks !== undefined) {
                waitingCallbacks.push(callback);
                return;
            }
            masterInflight.set(cacheKey, [callback]);
            const finishMaster = function (result, found) {
                const callbacks = masterInflight.get(cacheKey) || [];
                masterInflight.delete(cacheKey);
                if (!found) masterNotFound.add(cacheKey);
                callbacks.forEach(function (cb) {
                    try { cb(result); } catch (error) { console.log(error); }
                });
            };
            const perfToken = perfMasterRequest(dataid, code, keyinfo);
            try {
                this.postaxios('common/GetMasterData',
                    {
                        dataid: dataid,
                        code: String(code),
                        keyinfo: keyinfo,
                        others: param,
                        rowdata: rowdata
                    },
                    {
                        onSuccess: function (data) {
                            let returnData = data.returnData;
                            if (!isEmpty(returnData)) {
                                returnData = { ...returnData, dataid: dataid };
                            }
                            perfMasterResponse(perfToken, !isEmpty(returnData));
                            finishMaster(returnData, !isEmpty(returnData));
                        },
                        onError: function (data) {
                            perfMasterResponse(perfToken, false);
                            finishMaster(null, false);
                        }
                    }, waitmode
                );
            } catch (error) {
                console.log(error);
                finishMaster(null, false);
            }
        },
        //マスタデータ取得
        getRowMasterdata(coldefs, colinfo, rowdata, callback, extarnal) {
            try {
                this.postaxios('common/GetRowMasterData',
                    {
                        columns:coldefs,
                        colinfo: colinfo,
                        rowdata: rowdata,
                        type: isEnabled(extarnal)?"1":"0"
                    },
                    {
                        onSuccess: function (data) {
                            callback(data.rowdata);
                        },
                        onError: function (data) {
                            callback(null);
                        }
                    },'wait'
                );
            } catch (error) {
                console.log(error);
            }
        },
        //全SKUデータ取得
        getAllSKUdata(coldefs, colinfo, codes, callback) {
            try {
                this.postaxios('common/GetAllSKUData',
                    {
                        columns: coldefs,
                        colinfo: colinfo,
                        codes: codes
                    },
                    {
                        onSuccess: function (data) {
                            callback(data.rowdata);
                        },
                        onError: function (data) {
                            callback(null);
                        }
                    }
                );
            } catch (error) {
                console.log(error);
            }
        },
        //消費税率取得
        getTaxrate(date, callback) {
            try {
                this.postaxios('common/GetTaxRate', { code: date},
                    {
                        onSuccess: function (data) {
                            callback(Number(data.request), data.returnData);
                        },
                        onError: function (data) {
                            callback(0.1, [{"10":"10"}]);
                        }
                    }, true
                );
            } catch (error) {
                console.log(error);
            }
        },
        PLRowData(data, type, columninfo) {
            let column = columninfo.find(e => e.type === type);
            if(isEmpty(column)) return null;
            let pl = data[column.columnid];
            if (isEmpty(pl)) return null;
            if (pl.length === 0) return null;
            pl = pl.substring(1, pl.length - 1);     //先頭/末尾ダブルクォーテーション除去
            var rows = [];
            var items = pl.split('","');
            for (let i = 0; i < items.length; i++) {
                let value = items[i];
                let row = { rowid: i };
                row[column.columnid] = value;
                rows.push(row);
            }
            return rows;
        },
        PLTextData(data, colid) {
            let value = "";
            if(isEmpty(data)) return value;
            for (let r = 0; r < data.length; r++) {
                if (isEmpty(data[r][colid])) continue;
                if (value.length !== 0) value += ',';
                value += ('"' + data[r][colid] + '"');
            }
            return value;
        },
        //パネル情報からGridのIndexを取得
        gridindex(panel) {
            if (typeof panel !== "object") {
                if (gridlist.some(e => e.id === panel)) {
                    return gridlist.find(e => e.id === panel).index;
                }
                return -1;
            }
            if(gridlist.some(e => e.id === panel.id && e.type === panel.type)) {
                return gridlist.find(e => e.id === panel.id && e.type === panel.type).index;
            }
            if (isEmpty(panel.type)) {
                if (gridlist.some(e => e.id === panel.id)) {
                    return gridlist.find(e => e.id === panel.id).index;
                }
            }
            return -1;
        },
        //Storage保存用キーを取得
        statusKey(id, type, formid) {
            let gidx = this.gridindex({ id: id, type: type });
            if(gidx === -1) {
                return formid + "entry_" + id;
            } else {
                return formid + "entry_" + id + "_" + type;
            }
        },
        //識別IDを取得
        GridID(panel) {
            if (typeof panel !== "object") {
                var pnltype = "";
                if (gridlist.some(e => e.id === panel)) {
                    pnltype = gridlist.find(e => e.id === panel).type;
                }
                return "GID" + panel + "_" + pnltype;
            }
            return "GID" + panel.id + "_" + panel.type;
        },
        callform(state, callcontroller, targetWindow) {
            var menu = menus.find(e => e.controller === callcontroller);
            //別タブ起動
            let key = continueSession(user, menudata, menu, state);
            let newurl = callcontroller;
            if (newurl.indexOf('?') === -1) {
                newurl += "?key=" + key;
            } else {
                newurl += "&key=" + key;
            }
            const openUrl = '/' + newurl;
            if (targetWindow && !targetWindow.closed) {
                // 先に開いた空タブは親の sessionStorage 更新を自動では参照しないため、
                // 継続セッション情報を対象タブ側へ明示的に複写してから遷移させる。
                const continueData = sessionStorage.getItem(key);
                if (continueData !== null) {
                    targetWindow.sessionStorage.setItem(key, continueData);
                }
                targetWindow.location.href = openUrl;
                return targetWindow;
            }
            return window.open(openUrl);
        }
    }));

    function ensureValidLoginSession() {
        return hasValidLoginSession({ corpkey, account });
    }

    function handleLoginExpired() {
        dispatch(wait(false));
        dispatch(warnmsg("ページの有効期限が切れました。再度ログインしてください。"));
        dispatch(resetuser());
        dispatch(resetstore());
        dispatch(resetenv());
        history.push('/');
    }

    async function outputLog(url, error) {
        try {
            await axios.post("common/OutputLog", { "note": url, "errDescription": error.message }, getAxiosAuthConfig());
        } catch {
        }
    }

    function waittypeinterpret(waitmode) {
        //指定なし
        if (isEmpty(waitmode)) return 'backdrop';
        //nowait
        if (isEnabled(waitmode)) return 'nowait';
        //cursorwait
        if (waitmode === "wait") return 'wait';

        if (waitmode === "nowait") return 'nowait';
        if (waitmode === "backdrop") return 'backdrop';
        return 'backdrop';
    }
    async function postexecute(url, params, callback, waitmode) {
        activeAxiosCount += 1;
        var waittype = waittypeinterpret(waitmode);
        if (isbackdrop(waittype)) dispatch(wait(true));
        if (iswait(waittype)) {
            waitCursorCount += 1;
            dispatch(waitcursor(true));
        }
        try {
            let res = null;
            try {
                res = await axios.post(url, params, getAxiosAuthConfig());
            } catch (error) {
                dispatch(wait(false));
                const errDescription = getResponseErrorDescription(error);
                if (!isEmpty(errDescription)) {
                    dispatch(warnmsg(errDescription));
                    return;
                }
                if (isUnauthorizedResponse(error)) {
                    handleLoginExpired();
                    return;
                }
                console.log(error);
                dispatch(warnmsg("システムエラーが発生しました"));
                return;
            }
            const data = res.data;
            if (data.status) {
                if (!isEmpty(callback.onSuccess)) {
                    // React 17 は非同期コールバック内の setState をまとめないため、
                    // 応答1件ごとに setState の数だけ全画面が再描画されていた。
                    unstable_batchedUpdates(function () { callback.onSuccess(data); });
                } else {
                    dispatch(wait(false));
                }
            } else {
                if (!isEmpty(callback.onError)) {
                    unstable_batchedUpdates(function () { callback.onError(data); });
                } else {
                    dispatch(wait(false));
                    dispatch(warnmsg(buildPostErrorMessage(url, callback, data)));
                }
            }
        } catch (error) {
            console.log(error);
            dispatch(wait(false));
            dispatch(warnmsg("処理中にエラーが発生しました"));
            await outputLog(url, error);

        } finally {
            activeAxiosCount = Math.max(0, activeAxiosCount - 1);
            // 待機カーソルは点灯した本人が消す。
            // コールバックを渡した場合、従来は誰も消さず残り続けていた。
            if (iswait(waittype)) {
                waitCursorCount = Math.max(0, waitCursorCount - 1);
                if (waitCursorCount === 0) dispatch(waitcursor(false));
            }
        }
        function isbackdrop(waittype) {
            return waittype === 'backdrop';
        }
        function isnowait(waittype) {
            return waittype === 'nowait';
        }
        function iswait(waittype) {
            return waittype === 'wait';
        }
    }
    async function downloadexecute(url, params) {
        axios.get(url, getAxiosAuthConfig({
            params,
            responseType: "blob"
        }))
        .then(response => {
            const blob = new Blob([response.data], {
                type: response.data.type
            });
            const contentDisposition = response.headers["content-disposition"];
            const fileName = getFileName(contentDisposition)
            saveAs(blob, fileName);
        })
        .catch(error => {
            const errDescription = getResponseErrorDescription(error);
            if (!isEmpty(errDescription)) {
                dispatch(warnmsg(errDescription));
                return;
            }
            if (isUnauthorizedResponse(error)) {
                handleLoginExpired();
                return;
            }
            dispatch(warnmsg("ダウンロードができませんでした。指定のファイルは削除されている可能性があります。"));
        });
    }
   
    async function uploadexecute(url, params, callback) {
        dispatch(wait(true));
        try {
            const data = new FormData();
            data.append("corpkey", corpkey);
            data.append("account", account);
            if (params !== null) {
                Object.keys(params).forEach(key => {
                    const value = params[key];
                    if (Array.isArray(value)) {
                        value.forEach(entry => {
                            data.append(key + '[]', entry);
                        });
                    } else {
                        data.append(key, value);
                    }
                });
            }
            const headers = { "content-type": "multipart/form-data" };
            const res = await axios.post(url, data, getAxiosAuthConfig({ headers }));
            if (res.data.status) {
                if (!isEmpty(callback.onSuccess)) {
                    callback.onSuccess(res.data);
                }
            } else {
                if (!isEmpty(callback.onError)) {
                    callback.onError(res.data);
                } else {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(callback.errmsg)) {
                        msg = callback.errmsg;
                    }
                    if (!isEmpty(res.data.errDescription)) {
                        msg = res.data.errDescription;
                    }
                    dispatch(warnmsg(msg));
                }
                dispatch(wait(false));
            }
        } catch (error) {
            dispatch(wait(false));
            const errDescription = getResponseErrorDescription(error);
            if (!isEmpty(errDescription)) {
                dispatch(warnmsg(errDescription));
                return;
            }
            if (isUnauthorizedResponse(error)) {
                handleLoginExpired();
                return;
            }
            dispatch(warnmsg("システムエラーが発生しました"));
            console.log(error);
            await outputLog(url, error);
        }
    }
   function getFileName(contentDisposition) {
        let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
            contentDisposition.length
        );
        //デコードするとスペースが"+"になるのでスペースへ置換します
        fileName = decodeURI(fileName).replace(/\+/g, " ");

        return fileName;
    }

    return null;
}
